import type { VersionNumber } from './parseAppVersion';

export const versionIsOutdated = (
  version: VersionNumber,
  latest: VersionNumber
): boolean => {
  if (latest.major > version.major) {
    return true;
  }
  if (latest.minor > version.minor) {
    return true;
  }
  return latest.patch > version.patch;
};
